module.exports = __webpack_public_path__ + "img/es-pc-step-2.7cd90161.png";